export enum EAnchor {
  NEWSLETTER_REGISTRATION = `nl-registration`,
  PARTNER_LOCATION = `partner-location`,
}
